import { Paragraph } from '@welbe/web-design-system';
import { Container, ContainerButton, TitleContainer } from './Header.styles';
import React from 'react';

type HeaderProps = {
	image: string;
	title: string;
	slotHeader?: React.ReactNode;
};

export const Header = ({ image, title, slotHeader }: HeaderProps) => {
	return (
		<Container>
			<TitleContainer>
				<img src={image} width="50px" height="50px" alt="header logo" />
				<Paragraph fontWeight="500" fontSize="20px">
					{title}
				</Paragraph>
			</TitleContainer>
			<ContainerButton>{slotHeader}</ContainerButton>
		</Container>
	);
};
